import { render, staticRenderFns } from "./AddPageDetail.vue?vue&type=template&id=78677ef1"
import script from "./AddPageDetail.vue?vue&type=script&lang=js"
export * from "./AddPageDetail.vue?vue&type=script&lang=js"
import style0 from "./AddPageDetail.vue?vue&type=style&index=0&id=78677ef1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports